import { isAfter, isBefore, parseISO } from "date-fns";

import Form from "models/Form";

/**
 * This class represents a Widget fetched from the API including all the needed business functions/methods related.
 */
class Widget {
  static fromAPI = (data) => {
    const paymentModes = [];
    if (data?.use_preorder_direct_debit) {
      paymentModes.push("ONLINE");
    }
    if (data?.use_cashless_credit) {
      paymentModes.push("CASHLESS");
    }
    return {
      ...data,
      cashlessConfig: {
        isEnabled: data?.cashless_config?.is_enabled,
      },
      mainCurrency: {
        decimalPlaces: data?.currency_decimal_places,
        symbol: data?.currency_symbol,
        exchangeRate: {
          currencyCode: data?.exchange_rate?.code,
          denominator: data?.exchange_rate?.denominator,
          numerator: data?.exchange_rate?.numerator,
        },
      },
      maxWalletCount: data?.cashless_config?.maximum_wallet_count_per_user || 1,
      isChipPairingAllowed: data?.cashless_config?.is_short_tag_pairing_allowed || false,
      isSelfTagBlockingEnabled: data?.cashless_config?.is_self_tag_blocking_enabled || false,
      walletCreationModes: Widget.mapWalletCreationModesFromAPI(data),
      preorderConfig: {
        isNoAccountAllowed: data?.preorder_config?.preorder_without_account,
        noAccountForm: Form.fromAPI(data?.preorder_config?.preorder_without_account_form),
        validationStepForm: Form.fromAPI(data?.preorder_config?.validation_step_form),
        validationStepMessage: data?.preorder_config?.validation_step_message,
        paymentModes: data?.preorder_config?.payment_modes || ["ONLINE"],
        preorderShops: data?.preorder_config?.preorder_shops || [],
      },
      orgaTosUrl: data.orga_tos_url,
      weezeventTosUrl: data.weezevent_tos_url,
      currencyTypeToDisplay: data.currency_type_to_display,
      ticketPersonalSpaceUrl: data.ticket_personal_space_url,
      usersCanTransferTagFromOtherEvents: data.users_can_transfer_tag_from_other_events,
      isDonationEnabled: data?.donation_config?.is_enabled,
    };
  };

  /**
   * Compute the different modes available for the wallet creation.
   * @param {Object} data The widget data object return by the API.
   * @return {{
   * blank: boolean,
   * tag: boolean,
   * barcode: boolean,
   * mobilePayment: boolean
   * }} The computed object to describe the wallet creation modes available or not.
   */
  static mapWalletCreationModesFromAPI = (data) => ({
    tag: !!data?.wallet_creation_modes?.short_tag_start
      && isAfter(new Date(), parseISO(data.wallet_creation_modes.short_tag_start)),
    barcode: !!data?.wallet_creation_modes?.barcode_end
      && isBefore(new Date(), parseISO(data.wallet_creation_modes.barcode_end)),
    mobilePayment: !!data?.wallet_creation_modes?.mobile_payment_start
      && isAfter(new Date(), parseISO(data.wallet_creation_modes.mobile_payment_start)),
    blank: !!data?.wallet_creation_modes?.blank_start
      && isAfter(new Date(), parseISO(data.wallet_creation_modes.blank_start)),
  });
}

export default Widget;
